export function formatDateToFriendlyDate(inputDate, locales = undefined) {
    const date = new Date(inputDate);

    if (isNaN(date.getTime())) {
        return "—";
    }

    const dateOptions = {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric"
    };

    const timeOptions = {
        hour: "numeric",
        minute: "numeric"
    };

    const formattedDate = new Intl.DateTimeFormat(locales, dateOptions).format(date);
    const formattedTime = new Intl.DateTimeFormat(locales, timeOptions).format(date);

    return `${formattedDate} ${formattedTime}`;
}

export function convertUtcToLocalTime(inputDate) {
    if (!inputDate) return;
    const utc = new Date(inputDate);
    const offset = utc.getTimezoneOffset();
    return new Date(utc.getTime() - offset * 60000);
}
